import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const mutation = gql`
mutation updateOmiliaRequestType($id: ID!, $model: OmiliaRequestTypeInput!) {
  updateOmiliaRequestType(id: $id, input: $model){
    id
    name
    requestType {
      id
    }
  }
}`;

function updateOmiliaRequestType(id, model) {
  return apollo.client.mutate({
    mutation,
    variables: {
      id,
      model,
    },
  }).then((res) => res.data.updateOmiliaRequestType);
}

export default updateOmiliaRequestType;
